import { API_URL } from '../api'
import BGLeft from '../assets/images/BGLeft.svg'

/*
 * The app's page backdrop: the tenant's artwork anchored top left and scaled to
 * cover, over the tenant's flat page colour.
 *
 * theme.bgLeft is an image path served from the API; fall back to the bundled
 * asset when it's unset.
 */
const backdropImage = p => `url(${API_URL && p.theme.bgLeft ? API_URL + p.theme.bgLeft : BGLeft})`

const backdropColor = p => p.theme.homeBgColor ?? '#f4f7f8'

/** Paints the backdrop on an element that fills the viewport. */
export const pageBackground = p => `
  background-image: ${backdropImage(p)};
  background-repeat: no-repeat;
  background-position: top left;
  background-size: cover;
  background-color: ${backdropColor(p)};
`

/*
 * The same backdrop, resolved against the viewport rather than the element's own
 * box, so a small element anywhere on the page lines up pixel for pixel with the
 * full-viewport layer behind it.
 *
 * That alignment is the entire point, so it only holds while the layer it is
 * matching is itself viewport-sized and unscrolled — which is what AdviceLayout
 * is (100dvh, overflow: hidden; the step content scrolls inside StepScroll, not
 * the document). Repeat this on a scrolling page and the seam will drift.
 */
export const pageBackgroundFixed = p => `
  ${pageBackground(p)}
  background-attachment: fixed;
`
